// PrivacyPage — публичная политика конфиденциальности /privacy (R67b, V12 U-36-B).
// Статическая страница вне ProtectedRoute (видна без авторизации — ссылка из чекбокса 152-ФЗ).
// Контент минимальный и фактический: ПД, согласие 152-ФЗ, хранение в РФ, контакты,
// пояснение «лендинг-заявка → лид в CRM» (без выдуманных деталей, research §5.1).

import { Box, Button, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const CONTACT_EMAIL = 'info@jivochat';

/** Пункты политики (короткие фактические утверждения). */
const POLICY_ITEMS = [
  {
    title: 'Какие данные собираются',
    text: 'При отправке заявки с лендинга (/main) обрабатываются: имя, email, название компании, телефон (если указан) и текст обращения. Данные вводятся вами добровольно.',
  },
  {
    title: 'Зачем нужны данные',
    text: 'Заявка становится «лидом» в CRM «Упряжка»: менеджер связывается с вами по указанным контактам и отвечает на обращение. Данные не используются для иных целей.',
  },
  {
    title: 'Согласие (152-ФЗ)',
    text: 'Отправляя заявку, вы соглашаетесь на обработку персональных данных в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных». Согласие можно отозвать — напишите на адрес ниже.',
  },
  {
    title: 'Хранение',
    text: 'Данные хранятся на серверах, расположенных на территории Российской Федерации.',
  },
];

/** Публичная страница «Политика конфиденциальности». */
export function PrivacyPage(): JSX.Element {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Stack spacing={3}>
          <Typography variant="h4" component="h1">
            Политика конфиденциальности
          </Typography>
          <Typography variant="body1" color="text.secondary">
            CRM «Упряжка» (JivoChat) обрабатывает персональные данные с минимальной целью — ответить на
            вашу заявку. Ниже — краткое описание политики.
          </Typography>
          {POLICY_ITEMS.map((item) => (
            <Box key={item.title}>
              <Typography variant="h6" component="h2">
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.text}
              </Typography>
            </Box>
          ))}
          <Box>
            <Typography variant="h6" component="h2">
              Контакты
            </Typography>
            <Typography variant="body2" color="text.secondary">
              По вопросам обработки персональных данных: <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>
            </Typography>
          </Box>
          <Button component={RouterLink} to="/main" variant="outlined" sx={{ alignSelf: 'flex-start' }}>
            Вернуться на лендинг
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
